
import { z } from "zod";
import { UseCaseBrief } from "../UseCaseBrief";
import type { AssertSchemaMatchesClass } from "../../../utils/typeUtils";
import { ReportSchema } from "../../report/schemas/ReportBrief.schema";
import { ContentStatuses } from "../UseCaseChat";
import { JobStatuses } from "../../JobStatus";
import { RiskRanksWithNA } from "../../risk/Risk";


const _UseCaseBriefZod = z.object({
  useCaseChatId: z.string().default(""),

  reports: z.array(ReportSchema).default([]),

  status: z.enum(JobStatuses).default("none"),
  statusMessage: z.string().default(""),
  contentStatus: z.enum(ContentStatuses).default("none"),
  useCaseTitle: z.string().default("").transform((v) => (v.trim().length === 0 ? "<untitled>" : v.trim())),
  overallRiskRank: z.enum(RiskRanksWithNA).catch("n/a").default("n/a"),
  isStale: z.boolean().default(false),

});

// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _UseCaseBriefZod, Omit<UseCaseBrief, "jobIsActive" | "isSufficientForReportGeneration">>);
export const UseCaseBriefSchema = _UseCaseBriefZod.transform((data) => new UseCaseBrief(data));


export const UseCaseBriefListSchema = z.object({
  useCases: z.array(_UseCaseBriefZod).default([])
})

